<button
  type="button"
  class="nav-card"
  [class.nav-card-accent]="accent()"
  [class.nav-card-alert]="!!alert() && alertSeverity() === 'error'"
  [class.nav-card-warning]="!!alert() && alertSeverity() === 'warning'"
  (click)="cardClick.emit()"
>
  <div class="card-body">
    <div class="icon-wrapper">
      <mat-icon>{{ icon() }}</mat-icon>
    </div>

    <p class="card-title">{{ title() }}</p>
  </div>

  @if (alert(); as alertMessage) {
    <p class="card-alert" [title]="alertMessage">{{ alertMessage }}</p>
  }
</button>
